import { Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { isPortfolioViewer } from "@/lib/portfolioAccess";

export default function PortfolioGate({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!isPortfolioViewer(user?.email)) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center gap-3 py-24 text-center px-6">
        <Lock className="h-8 w-8 text-muted-foreground/40" />
        <p className="text-sm font-semibold text-foreground">This page isn't publicly available yet</p>
        <p className="text-xs text-muted-foreground max-w-xs">
          It's still being drafted. Check back later, or ask the project owner directly.
        </p>
        <Link to="/studio" className="text-xs text-accent hover:underline mt-2">
          Back to dashboard
        </Link>
      </div>
    );
  }

  return <>{children}</>;
}
